export enum AppCode {
  HTF = 'A00.V',
  OM = 'A09.OM',
  AC = 'A10.AC',
  PP = 'A10.PP',
  BD = 'A05.BD',
  KS = 'A01.KS',
  SM = 'A01.SM',
  ER = 'A04.ER',
  CRM = 'A06.CRM',
  MW = 'A03.MW',
  JS = 'A11.JS',
  ECAPP = 'A15.EC',
  BA = 'A12.BA',
  DM = 'A07.DM',
  PM = 'A08.PM',
  DF ='A02.DF',
  AU = 'A23.AU',
  LM = 'A13.LM',
  FU = 'A27.FU',
  AI = 'B01.AI',
  SMB = 'A01.SM',
  PAC = 'A01.KS',
}
